import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { membersCacheState } from '@atom/setting/membersState';
import { getMembers, setMembersCache } from '@store/firebase/user/getUsers';

/**
 * 앱 마운트 시 멤버 목록을 1회 로드하여
 * Recoil atom + 모듈 캐시 양쪽에 동기화하는 훅
 *
 * Main.tsx 또는 최상위 레이아웃에서 1회 호출
 */
export function useMembersInit() {
  const [members, setMembers] = useRecoilState(membersCacheState);

  useEffect(() => {
    if (members !== null) return; // 이미 로드됨

    let cancelled = false;

    (async () => {
      const fetched = await getMembers();
      if (!cancelled) {
        setMembers(fetched);
        setMembersCache(fetched);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [members, setMembers]);

  return members;
}

/**
 * 멤버 캐시 강제 리프레시
 * 멤버 추가/삭제 등 변경 발생 시 호출
 */
export function useRefreshMembers() {
  const [, setMembers] = useRecoilState(membersCacheState);

  return async () => {
    // 캐시 무효화 후 재조회
    const { invalidateMembersCache } = await import(
      '@store/firebase/user/getUsers'
    );
    invalidateMembersCache();
    const fresh = await getMembers();
    setMembers(fresh);
    setMembersCache(fresh);
  };
}
